import {get} from '@/lib/fetcher.js'

export async function getCandidateAvailabilities(params = {}) {
    return await get("/admin/candidate_availabilities", params);
}
